export const AD_PLACEMENTS = [
  { key: "home_top", label: "Начало — горен банер" },
  { key: "home_infeed", label: "Начало — между новините" },
  { key: "sidebar", label: "Странична лента" },
  { key: "article_top", label: "Статия — над съдържанието" },
  { key: "article_bottom", label: "Статия — под съдържанието" },
  { key: "footer", label: "Преди футъра (всички страници)" },
];

export const AD_TYPES = [
  { key: "banner", label: "Банер с изображение и линк" },
  { key: "adsense", label: "Google AdSense код" },
];

export const placementLabel = (key) =>
  AD_PLACEMENTS.find((p) => p.key === key)?.label || key;

export const typeLabel = (key) =>
  AD_TYPES.find((t) => t.key === key)?.label || key;
